import Enum from '@square/dashboard-utilities/utils/enum';
import { retailSubscriptionModalEvents, restaurantsSubscriptionModalEvents, kdsSubscriptionModalEvents } from '@dashboard/shared-ui/events/vertical-subscriptions/event-catalog';
import { AllDevicesImageConfig } from '@dashboard/shared-ui/utils/rst-all-devices-config';
import { localeForConfig } from '@dashboard/shared-ui/utils/rst-upsell-config';
import Feature from '@square/dashboard-utilities/utils/sub2/feature';
import { FeeRateConstraint } from '@square/dashboard-protos/models/squareup/feeplans/model';
import { UsageUnitType as ProtoUsageUnitType } from '@square/dashboard-protos/models/squareup/sub2/data';
import Sub2Subscription from '@square/dashboard-data/models/squareup/sub2/subscription';

// This represent the team plus feature offered by the new 2023 retail plan
export const RETAIL_REPRICING_2023_PLUS_TEAM_PLUS_FEATURE = 'EMPLOYEE_MANAGEMENT';
// This represent the shift plus feature offered by the new 2023 retail plan
export const RETAIL_REPRICING_2023_PLUS_SHIFT_PLUS_FEATURE = 'SHIFTS_SCHEDULING_ADVANCED';
// This represent the shift free feature included in the new 2023 retail plan
export const RETAIL_REPRICING_2023_PLUS_SHIFT_FREE_FEATURE = 'SHIFTS_SCHEDULING_BASIC';
export const UsageUnitType = new Enum(['INVALID', 'EMPLOYEE', 'RETAIL_DEVICE', 'CUSTOMER', 'APPOINTMENTS_EMPLOYEE', 'RESTAURANTS_LOCATION', 'RESTAURANTS_ADDITIONAL_DEVICE', 'RESTAURANTS_MOBILE_LOCATION', 'RETAIL_LOCATION', 'RETAIL_ADDITIONAL_DEVICE', 'EMPLOYEE_MANAGEMENT_LOCATION', 'SPOS_DEVICE_SETTINGS_DEVICE', 'REACHABLE_CONTACTS', 'LOYALTY_LOCATIONS', 'LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_1', 'LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_2', 'LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_3', 'LOYALTY_TRANSACTIONS', 'LOYALTY_TRANSACTIONS_TIER', 'LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_1', 'LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_2', 'LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_3', 'MARKETING_SMS_MESSAGES', 'KDS_DEVICE', 'APPOINTMENTS_LOCATIONS', 'MESSAGES_LOCATION', 'SHIFTS_TEAM_MEMBER', 'COMMS_TEAM_MEMBER', 'STAFF_TEAM_MEMBER']);
export const Vertical = new Enum(['APPOINTMENTS', 'KDS', 'LOYALTY', 'MARKETING', 'RESTAURANTS', 'RESTAURANTS_PRO', 'RESTAURANTS_PLUS', 'RETAIL', 'TEAM_MANAGEMENT', 'APPOINTMENTS_GROUP', 'RESTAURANTS_MOBILE', 'SHIFTS_GROUP', 'SQUARE_ONLINE', 'PAYPROD_PRICING_PLAN', 'INVOICES', 'MESSAGES', 'SPOS_DUAL_MODE_GROUP', 'SPOS_DUAL_MODE_V3_GROUP', 'SPOS_TIERED_V1_GROUP', 'STAFF', 'FNB_KIOSK']);
export const Tier = new Enum(['FREE', 'PLUS']);
export const KDS_PLAN_TOKEN = 'kds';
export const RETAIL_PLAN_TOKEN = 'retail-pos-per-location';
export const RETAIL_REPRICING_2023_PLAN_TOKEN = 'retail-pos-per-location-2023';
export const LEGACY_RESTAURANTS_PLAN_TOKEN = 'restaurants';
export const RESTAURANTS_PRO_PLAN_TOKEN = 'restaurants-pro';
export const RESTAURANTS_FREE_TIER_PLAN_TOKEN = 'restaurants-free';
export const RESTAURANTS_PLUS_TIER_PLAN_TOKEN = 'restaurants-plus';
export const RESTAURANTS_PREMIUM_TIER_PLAN_TOKEN = 'restaurants-premium';
export const RESTAURANTS_PLAN_GROUP_TOKEN = 'restaurants-group';
export const ADDITIONAL_RESTAURANTS_POS_PLAN_TOKEN = 'additional-restaurants-pos';
export const RESTAURANTS_MOBILE_PLAN_TOKEN = 'restaurants-mobile';
export const FNB_KIOSK_PLAN_TOKEN = 'fnb-kiosk';
export const LEGACY_TEAM_MANAGEMENT_PLAN_TOKEN = 'employee-management-per-location';
export const TEAM_MANAGEMENT_PLAN_TOKEN = 'team-management';
export const MARKETING_PLAN_TOKEN = 'marketing';
export const MARKETING_SMS_PLAN_TOKEN = 'marketing-sms';
export const APPOINTMENTS_PLAN_TOKEN = 'appointments';
export const APPOINTMENTS_GROUP = 'appointments-group';
export const APPOINTMENTS_FREE_PLAN_TOKEN = 'appointments-free';
export const APPOINTMENTS_PLUS_PLAN_TOKEN = 'appointments-plus';
export const APPOINTMENTS_PREMIUM_PLAN_TOKEN = 'appointments-premium';
export const INVOICES_PLUS_PLAN_TOKEN = 'invoices-plus';
export const INVOICES_PLUS_APP_STORE_PLAN_TOKEN = 'invoices-plus-app-store';
export const INVOICES_PLUS_GOOGLE_PLAY_PLAN_TOKEN = 'invoices-plus-google-play';
export const MESSAGES_PLUS_PLAN_TOKEN = 'messages-plus';
export const SHIFTS_GROUP = 'shifts-group';
export const SHIFTS_PLUS_PLAN_TOKEN = 'shifts-plus';
export const SQUARE_ONLINE_GROUP = 'ecom-so-plans';
export const PAYPROD_PRICING_V0_TOKEN = 'payprod_pricing_v0';
export const PAYPROD_PRICING_V1_TOKEN = 'payprod_pricing_v1';
export const PAYPROD_PRICING_V2_TOKEN = 'payprod_pricing_v2';
export const PAYPROD_PRICING_V2_NO_HARDWARE_TOKEN = 'payprod_pricing_v2_no_hardware';
export const PAYPROD_PRICING_TOKENS = [PAYPROD_PRICING_V0_TOKEN, PAYPROD_PRICING_V1_TOKEN, PAYPROD_PRICING_V2_TOKEN, PAYPROD_PRICING_V2_NO_HARDWARE_TOKEN];
export const RETAIL_PLAN_TOKENS = [RETAIL_PLAN_TOKEN, RETAIL_REPRICING_2023_PLAN_TOKEN];
export const PAID_RESTAURANTS_PLAN_TOKENS = [LEGACY_RESTAURANTS_PLAN_TOKEN, RESTAURANTS_PRO_PLAN_TOKEN, RESTAURANTS_PLUS_TIER_PLAN_TOKEN, RESTAURANTS_PREMIUM_TIER_PLAN_TOKEN];
export const PAID_RESTAURANTS_VERTICALS = [Vertical.RESTAURANTS, Vertical.RESTAURANTS_PRO];
export const SPOS_DUAL_MODE_GROUP = 'spos-dual-mode-group-plans';
export const SPOS_PAYMENTS_PAYG_TOKEN = 'spos-payments-payg';
export const SPOS_PAYMENTS_S2S_TOKEN = 'spos-payments-s2s';
export const SPOS_POS_TOKEN = 'spos-pos';
export const SPOS_DUAL_MODE_TOKENS = [SPOS_PAYMENTS_PAYG_TOKEN, SPOS_PAYMENTS_S2S_TOKEN, SPOS_POS_TOKEN];
export const SPOS_DUAL_MODE_V3_GROUP = 'spos-dual-mode-v3-group-plans';
export const SPOS_PAYMENTS_PAYG_V3_TOKEN = 'spos-payments-payg-v3';
export const SPOS_POS_PAYG_V3_TOKEN = 'spos-pos-payg-v3';
export const SPOS_POS_S2S_V3_TOKEN = 'spos-pos-s2s-v3';
export const SPOS_DUAL_MODE_V3_TOKENS = [SPOS_PAYMENTS_PAYG_V3_TOKEN, SPOS_POS_PAYG_V3_TOKEN, SPOS_POS_S2S_V3_TOKEN];
export const SPOS_TIERED_V1_GROUP = 'spos-tiered-v1-group-plans';
export const SPOS_PAYG_TIERED_V1_TOKEN = 'spos-tiered-v1-payg';
export const SPOS_S2S_TIERED_V1_TOKEN = 'spos-tiered-v1-s2s';
export const SPOS_TIERED_V1_TOKENS = [SPOS_PAYG_TIERED_V1_TOKEN, SPOS_S2S_TIERED_V1_TOKEN];
export const SPOS_TOKENS = [...SPOS_DUAL_MODE_TOKENS, ...SPOS_TIERED_V1_TOKENS, ...SPOS_DUAL_MODE_V3_TOKENS];
export const STAFF_GROUP = 'staff-group';
export const STAFF_PER_LOCATION_GROUP = 'staff-group-per-location';
export const STAFF_GROUP_V2 = 'staff-group-v2';
export const STAFF_PER_LOCATION_GROUP_V2 = 'staff-group-v2-per-location';
export const PAYROLL_FOR_EMPLOYEES_WITH_FREE_TRIALS_PLAN_TOKEN = 'payroll_for_employees_with_free_trials';
export const PAYROLL_FOR_EMPLOYEES_WITH_FREE_TRIALS_V2_PLAN_TOKEN = 'payroll_for_employees_with_free_trials_v2';
export const PAYROLL_PLAN_TOKENS_TO_CUSTOMIZE_PRICING_LABEL = [PAYROLL_FOR_EMPLOYEES_WITH_FREE_TRIALS_PLAN_TOKEN, PAYROLL_FOR_EMPLOYEES_WITH_FREE_TRIALS_V2_PLAN_TOKEN];
export const LOYALTY_PAYG_PLAN_TOKEN = 'loyalty_payg_per_location';
export const LOYALTY_PAYG_PER_LOCATION_V2_PLAN_TOKEN = 'loyalty_payg_per_location_v2';
export const LOYALTY_PAYG_PER_USAGE_ONLY_PLAN_TOKEN = 'loyalty_payg_per_usage_only';
export const LOYALTY_TIERED_PLAN_TOKEN = 'loyalty_tpl_postpay';
export const LOYALTY_TIERED_PLAN_TOKEN_POS = 'loyalty_pos_tpl_postpay';
export const LOYALTY_PRE_PAY_TIERED_PLAN_TOKEN = 'loyalty_transactions_per_location';
export const LOYALTY_PRE_PAY_TIERED_PLAN_TOKEN_POS = 'loyalty_pos_transactions_per_location';
export const LOYALTY_POST_PAY_TIERED_PLAN_TOKEN__DEPRECATED = 'loyalty_transactions_per_location_postpay'; // Deprecated in favor of loyalty_tpl_postpay

export const LOYALTY_POST_PAY_PAYG_SUBSCRIPTION_SOURCE = 'loyalty-postpay-payg-manage';
export const LOYALTY_POST_PAY_PAYG_PER_LOCATION_V2_SUBSCRIPTION_SOURCE = 'loyalty-postpay-payg-per-location-v2-manage';
export const LOYALTY_POST_PAY_PAYG_PER_USAGE_ONLY_SUBSCRIPTION_SOURCE = 'loyalty-postpay-payg-per-usage-only-manage';
export const LOYALTY_POST_PAY_TIERED_SUBSCRIPTION_SOURCE = 'loyalty-postpay-tiered-manage';
export const LOYALTY_POST_PAY_TIERED_SUBSCRIPTION_POS_SOURCE = 'loyalty-postpay-tiered-pos-manage';
export const LOYALTY_POST_PAY_TIERED_SUBSCRIPTION_SOURCE_REACTIVATE = 'loyalty-postpay-tiered-reactivate';
export const LOYALTY_POST_PAY_TIERED_SUBSCRIPTION_POS_SOURCE_REACTIVATE = 'loyalty-postpay-tiered-pos-reactivate';
export const LOYALTY_POST_PAY_PAYG_SUBSCRIPTION_SOURCE_REACTIVATE = 'loyalty-postpay-payg-reactivate';
export const LOYALTY_POST_PAY_PAYG_PER_LOCATION_V2_SUBSCRIPTION_SOURCE_REACTIVATE = 'loyalty-postpay-payg-per-location-v2-reactivate';
export const LOYALTY_POST_PAY_PAYG_PER_USAGE_ONLY_SUBSCRIPTION_SOURCE_REACTIVATE = 'loyalty-postpay-payg-per-usage-only-reactivate';

// group loyalty's dashboard specific postpay plan tokens together.
export const LOYALTY_DASHBOARD_POSTPAY_PLAN_GROUP = [LOYALTY_TIERED_PLAN_TOKEN, LOYALTY_PAYG_PLAN_TOKEN, LOYALTY_PAYG_PER_LOCATION_V2_PLAN_TOKEN, LOYALTY_PAYG_PER_USAGE_ONLY_PLAN_TOKEN];
async function getEmployeeManagementActiveSubunits(publicEmSubscriptionsService) {
  const activeLocationsResponse = await publicEmSubscriptionsService.fetchLocationsWithEmployeeCount({});
  return activeLocationsResponse.locationsWithEmployeeCount.map(location => location.locationToken);
}

/*
 ** In order to figure out which plan retail users originally signed up with
 ** we need to look whether they have the RETAIL_PRICING_2023 feature which comes
 ** with the retail-pos-per-location-2023 plan.
 */
function didSignUpWithNewPlan(currentPlanFeatures) {
  // return new plan if there are no features
  if (!currentPlanFeatures) {
    return true;
  }
  return currentPlanFeatures.some(item => item.feature === 'RETAIL_PRICING_2023');
}

/*
 Warning: The retail plan token is now dynamically set in getRetailPlanToken while It is hardcoded in VERTICAL_CONFIGURATION
          Use the getRetailPlanToken method instead of VERTICAL_CONFIGURATION enum to access the retail plan token
          VERTICAL_CONFIGURATION will be replaced to use the 2023 plan token in RETAIL-24580 once full migration happens.
*/
// there should be one key for each Vertical enum value
export const VERTICAL_CONFIGURATION = {
  KDS: {
    vertical: Vertical.KDS,
    planToken: KDS_PLAN_TOKEN,
    subscriptionModalEvents: kdsSubscriptionModalEvents,
    subscriptionFeature: Feature.KDS
  },
  RETAIL: {
    vertical: Vertical.RETAIL,
    planToken: RETAIL_PLAN_TOKEN,
    productNameKey: 'subscriptions.sub2.retail.productName',
    subscriptionFeature: Feature.RETAIL,
    subscriptionModalEvents: retailSubscriptionModalEvents
  },
  RESTAURANTS: {
    vertical: Vertical.RESTAURANTS,
    productNameKey: 'subscriptions.sub2.restaurants.productName',
    planToken: LEGACY_RESTAURANTS_PLAN_TOKEN,
    subscriptionFeature: Feature.RESTAURANTS,
    subscriptionModalEvents: restaurantsSubscriptionModalEvents
  },
  RESTAURANTS_PLUS: {
    planToken: RESTAURANTS_PLUS_TIER_PLAN_TOKEN,
    subscriptionFeature: Feature.RESTAURANTS_PLUS,
    subscriptionModalEvents: restaurantsSubscriptionModalEvents,
    vertical: Vertical.RESTAURANTS.PLUS
  },
  RESTAURANTS_PRO: {
    vertical: Vertical.RESTAURANTS_PRO,
    productNameKey: 'subscriptions.sub2.restaurants.productName',
    planToken: RESTAURANTS_PRO_PLAN_TOKEN,
    subscriptionFeature: Feature.RESTAURANTS,
    subscriptionModalEvents: restaurantsSubscriptionModalEvents
  },
  FNB_KIOSK: {
    vertical: Vertical.FNB_KIOSK,
    productNameKey: 'subscriptions.sub2.fnb.kiosk.productName',
    planToken: FNB_KIOSK_PLAN_TOKEN,
    subscriptionFeature: Feature.FNB_KIOSK,
    subscriptionModalEvents: restaurantsSubscriptionModalEvents
  },
  MARKETING: {
    vertical: Vertical.MARKETING
  },
  LOYALTY: {
    vertical: Vertical.LOYALTY
  },
  APPOINTMENTS: {
    vertical: Vertical.APPOINTMENTS
  },
  TEAM_MANAGEMENT: {
    vertical: Vertical.TEAM_MANAGEMENT,
    planToken: LEGACY_TEAM_MANAGEMENT_PLAN_TOKEN,
    skipCreateSubscription: true,
    createSubscriptionCallback: async ({
      publicEmSubscriptionsService,
      teamPlusUnbundled
    }) => {
      const activeSubunits = await getEmployeeManagementActiveSubunits(publicEmSubscriptionsService);
      await publicEmSubscriptionsService.updateSubscribedLocations({
        locationTokens: activeSubunits
      });
      return Sub2Subscription.create({
        planToken: teamPlusUnbundled ? TEAM_MANAGEMENT_PLAN_TOKEN : LEGACY_TEAM_MANAGEMENT_PLAN_TOKEN
      });
    },
    unselectedPlanComponentCallback: async ({
      publicEmSubscriptionsService
    }) => {
      const activeSubunits = await getEmployeeManagementActiveSubunits(publicEmSubscriptionsService);
      await publicEmSubscriptionsService.updateSubscribedLocations({
        locationTokens: activeSubunits,
        updateSubscriptionStatus: false
      });
    },
    getPricingInfoUsageData: async ({
      publicEmSubscriptionsService
    }) => {
      const activeSubunits = await getEmployeeManagementActiveSubunits(publicEmSubscriptionsService);
      return {
        unitUsages: [{
          unitType: ProtoUsageUnitType.EMPLOYEE_MANAGEMENT_LOCATION,
          count: activeSubunits.length
        }]
      };
    }
  },
  // Tests for these configurations are in acceptance/sub2-subscriptions-test.js
  APPOINTMENTS_GROUP: {
    vertical: Vertical.APPOINTMENTS_GROUP
  },
  RESTAURANTS_GROUP: {
    vertical: Vertical.RESTAURANTS,
    subscriptionModalEvents: restaurantsSubscriptionModalEvents
  },
  SPOS_DUAL_MODE_GROUP: {
    vertical: Vertical.SPOS_DUAL_MODE_GROUP
  },
  SPOS_DUAL_MODE_V3_GROUP: {
    vertical: Vertical.SPOS_DUAL_MODE_V3_GROUP
  },
  SPOS_TIERED_V1_GROUP: {
    vertical: Vertical.SPOS_TIERED_V1_GROUP
  },
  SHIFTS_GROUP: {
    vertical: Vertical.SHIFTS_GROUP
  },
  SQUARE_ONLINE: {
    vertical: Vertical.SQUARE_ONLINE
  },
  STAFF_GROUP: {
    vertical: Vertical.STAFF
  },
  PAYPROD_PRICING: {
    vertical: Vertical.PAYPROD_PRICING_PLAN
  },
  INVOICES: {
    planToken: INVOICES_PLUS_PLAN_TOKEN,
    productNameKey: 'subscriptions.sub2.invoices.productName',
    vertical: Vertical.INVOICES,
    getCancelModalOptions: async ({
      userUnits,
      i18n,
      invoiceFees,
      merchantMetadataStore
    }) => {
      try {
        const unitToken = userUnits.merchantSubunits?.[0].token;
        await Promise.all([merchantMetadataStore.refresh(unitToken), invoiceFees.load(unitToken)]);
        const canShowTieredPricing = invoiceFees.showTieredPricingComms;
        const invoicesPayPageFreeFee = invoiceFees.formattedFreeInvoiceRate;
        const invoicesPayPagePlusFee = invoiceFees.formattedPlusInvoiceRate;
        const achMaxFeeCap = invoiceFees.processingFees?.invoicesAchPlus?.formattedConstraints[FeeRateConstraint.Type.MAX_FEE];
        let customWarningMessage;
        if (canShowTieredPricing) {
          if (invoicesPayPageFreeFee && invoicesPayPagePlusFee) {
            if (invoiceFees.showAchMaxFeeCap) {
              customWarningMessage = i18n.t('subscriptions.sub2.manageModal.invoices.cancelWarningWithACH', {
                freeRate: invoicesPayPageFreeFee,
                plusRate: invoicesPayPagePlusFee,
                achMaxFeeCap
              });
            } else {
              customWarningMessage = i18n.t('subscriptions.sub2.manageModal.invoices.cancelWarning', {
                freeRate: invoicesPayPageFreeFee,
                plusRate: invoicesPayPagePlusFee
              });
            }
          } else {
            if (invoiceFees.showAchMaxFeeCap) {
              customWarningMessage = i18n.t('subscriptions.sub2.manageModal.invoices.cancelWarningNoFeesWithACH');
            } else {
              customWarningMessage = i18n.t('subscriptions.sub2.manageModal.invoices.cancelWarningNoFees');
            }
          }
        }
        return {
          customWarningMessage
        };
      } catch {
        return {};
      }
    }
  },
  MESSAGES: {
    planToken: MESSAGES_PLUS_PLAN_TOKEN,
    vertical: Vertical.MESSAGES
  }
};
export function getDowngradeHeroImage(vertical, i18n, userInfo, assetMap) {
  const locale = userInfo.browserLanguage;
  switch (vertical) {
    case Vertical.RESTAURANTS:
    case Vertical.RESTAURANTS_PRO:
      return {
        description: i18n.t('sharedUi.images.restaurants.allDevices.hero.description'),
        responsiveImageSource: AllDevicesImageConfig[localeForConfig(userInfo.countryCode)]['src'],
        height: 222,
        width: 545
      };
    case Vertical.RETAIL:
      return {
        description: i18n.t('sharedUi.modals.loseAccessModal.hero.description.retail'),
        responsiveImageSource: {
          '1x': assetMap.resolve(`/@dashboard/shared-ui/images/rtl/rtl-lose-access-modal-hero-${locale}@1x.png`),
          '2x': assetMap.resolve(`/@dashboard/shared-ui/images/rtl/rtl-lose-access-modal-hero-${locale}@2x.png`)
        },
        height: 275,
        width: 395
      };
    default:
      return null;
  }
}

/*
 * Given a plan token, determine the usage unit type(s) that should be zeroed out for the minimum subscription usage.
 * This can be helpful to calculate an estimated cost for a multi-bucket plan for a pre-sale subscription, when
 * a seller's subscription does not have any usage data yet.
 */
export function getIgnoredUnitTypesForMinimumSubscriptionUsage(planToken) {
  switch (planToken) {
    case LOYALTY_TIERED_PLAN_TOKEN:
    case LOYALTY_TIERED_PLAN_TOKEN_POS:
    case LOYALTY_PRE_PAY_TIERED_PLAN_TOKEN:
    case LOYALTY_PRE_PAY_TIERED_PLAN_TOKEN_POS:
      return new Set([ProtoUsageUnitType.LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_2, ProtoUsageUnitType.LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_3]);
    case LOYALTY_PAYG_PER_LOCATION_V2_PLAN_TOKEN:
      return new Set([ProtoUsageUnitType.LOYALTY_PAYG_LOCATION]);
    case LOYALTY_PAYG_PLAN_TOKEN:
    case LOYALTY_PAYG_PER_USAGE_ONLY_PLAN_TOKEN:
      return new Set([ProtoUsageUnitType.LOYALTY_PAYG_USAGE]);
    default:
      return null;
  }
}
const planTokenMap = {
  [RETAIL_PLAN_TOKEN]: VERTICAL_CONFIGURATION.RETAIL,
  [RETAIL_REPRICING_2023_PLAN_TOKEN]: VERTICAL_CONFIGURATION.RETAIL,
  [RESTAURANTS_PRO_PLAN_TOKEN]: VERTICAL_CONFIGURATION.RESTAURANTS_PRO,
  [LEGACY_RESTAURANTS_PLAN_TOKEN]: VERTICAL_CONFIGURATION.RESTAURANTS,
  [RESTAURANTS_PLAN_GROUP_TOKEN]: VERTICAL_CONFIGURATION.RESTAURANTS_GROUP,
  [KDS_PLAN_TOKEN]: VERTICAL_CONFIGURATION.KDS,
  marketing: VERTICAL_CONFIGURATION.MARKETING,
  'loyalty-transactions': VERTICAL_CONFIGURATION.LOYALTY,
  'loyalty-transactions-2': VERTICAL_CONFIGURATION.LOYALTY,
  loyalty_location_transactions_tiers: VERTICAL_CONFIGURATION.LOYALTY,
  [APPOINTMENTS_PLAN_TOKEN]: VERTICAL_CONFIGURATION.APPOINTMENTS,
  [LEGACY_TEAM_MANAGEMENT_PLAN_TOKEN]: VERTICAL_CONFIGURATION.TEAM_MANAGEMENT,
  [TEAM_MANAGEMENT_PLAN_TOKEN]: VERTICAL_CONFIGURATION.TEAM_MANAGEMENT,
  [KDS_PLAN_TOKEN]: VERTICAL_CONFIGURATION.KDS,
  [APPOINTMENTS_GROUP]: VERTICAL_CONFIGURATION.APPOINTMENTS_GROUP,
  example: VERTICAL_CONFIGURATION.RETAIL,
  [SHIFTS_GROUP]: VERTICAL_CONFIGURATION.SHIFTS_GROUP,
  [SQUARE_ONLINE_GROUP]: VERTICAL_CONFIGURATION.SQUARE_ONLINE,
  [INVOICES_PLUS_PLAN_TOKEN]: VERTICAL_CONFIGURATION.INVOICES,
  [PAYPROD_PRICING_V0_TOKEN]: VERTICAL_CONFIGURATION.PAYPROD_PRICING,
  [PAYPROD_PRICING_V1_TOKEN]: VERTICAL_CONFIGURATION.PAYPROD_PRICING,
  [PAYPROD_PRICING_V2_TOKEN]: VERTICAL_CONFIGURATION.PAYPROD_PRICING,
  [PAYPROD_PRICING_V2_NO_HARDWARE_TOKEN]: VERTICAL_CONFIGURATION.PAYPROD_PRICING,
  [FNB_KIOSK_PLAN_TOKEN]: VERTICAL_CONFIGURATION.FNB_KIOSK,
  [MESSAGES_PLUS_PLAN_TOKEN]: VERTICAL_CONFIGURATION.MESSAGES,
  [SPOS_DUAL_MODE_GROUP]: VERTICAL_CONFIGURATION.SPOS_DUAL_MODE_GROUP,
  [SPOS_DUAL_MODE_V3_GROUP]: VERTICAL_CONFIGURATION.SPOS_DUAL_MODE_V3_GROUP,
  [SPOS_TIERED_V1_GROUP]: VERTICAL_CONFIGURATION.SPOS_TIERED_V1_GROUP,
  [STAFF_GROUP]: VERTICAL_CONFIGURATION.STAFF_GROUP,
  [STAFF_PER_LOCATION_GROUP]: VERTICAL_CONFIGURATION.STAFF_GROUP,
  [STAFF_GROUP_V2]: VERTICAL_CONFIGURATION.STAFF_GROUP,
  [STAFF_PER_LOCATION_GROUP_V2]: VERTICAL_CONFIGURATION.STAFF_GROUP,
  [LOYALTY_PAYG_PLAN_TOKEN]: VERTICAL_CONFIGURATION.LOYALTY,
  [LOYALTY_TIERED_PLAN_TOKEN]: VERTICAL_CONFIGURATION.LOYALTY,
  [LOYALTY_PAYG_PER_LOCATION_V2_PLAN_TOKEN]: VERTICAL_CONFIGURATION.LOYALTY,
  [LOYALTY_PAYG_PER_USAGE_ONLY_PLAN_TOKEN]: VERTICAL_CONFIGURATION.LOYALTY
};
export const verticalConfigMocks = {
  getRetailPlanToken(featureFlagService, userSubscriptionsService) {
    const {
      isSubscribedToRetail,
      isRetailFree,
      isRetailPending,
      isRetailPresale,
      subscriptionFeatureStatus
    } = userSubscriptionsService;
    const newPlanEnabled = featureFlagService.isEnabled('retailrepricing/should_use_2023_pricing_plan');
    const signedUpWithNewPlan = didSignUpWithNewPlan(subscriptionFeatureStatus);
    if (newPlanEnabled) {
      const shouldViewLegacyRetailPlan = !signedUpWithNewPlan && isSubscribedToRetail;

      // rules here: https://docs.google.com/document/d/15eLUKaazJsFgA4KtrLkVaL4RoAzRt_WqfnNAHI8M4oo/edit#bookmark=id.mntzqrz2bun3
      // for subscription types in green rows, we would like to return the new plan token
      // for types in yellow rows, we should return the old plan token if they signed up with it
      if (isRetailFree || isRetailPending || isRetailPresale) {
        return RETAIL_REPRICING_2023_PLAN_TOKEN;
      } else if (shouldViewLegacyRetailPlan) {
        return RETAIL_PLAN_TOKEN;
      }
      return RETAIL_REPRICING_2023_PLAN_TOKEN;
    } else {
      // if the feature flag is false and they signed up with new plan, respect that
      return signedUpWithNewPlan ? RETAIL_REPRICING_2023_PLAN_TOKEN : RETAIL_PLAN_TOKEN;
    }
  }
};
export function getRetailPlanToken(featureFlagService, userSubscriptionsService) {
  return verticalConfigMocks.getRetailPlanToken(featureFlagService, userSubscriptionsService);
}
export function getVertical(planToken) {
  return planTokenMap[planToken] || {};
}